import React, { useEffect, useState } from 'react';
import {
    Paper,
    TableContainer,
    Table,
    TableRow,
    TableHead,
    TableCell,
    makeStyles,
    TableBody,
    TablePagination,
    TableSortLabel,
} from '@material-ui/core';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createIMCDraftRequest } from '../../draftDocument/store/actions';
import axios from 'axios';
import { CommonConfig } from '../../../config/common-config';


function EnhancedTableHead(props) {
    const { classes, headcells, action, order, orderBy, onRequestSort, stageId } = props;

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead size="medium" className={classes.thead}>
            <TableRow>
                {/* <TableCell className={classes.TableHeadCss} width="10% !important">SL No</TableCell> */}
                {headcells.map((headRow) => {
                    //console.log(headRow, "Header Row");
                    return (
                        <TableCell key={headRow.id} align="left" sortDirection={orderBy === headRow.id ? order : false}>
                            <TableSortLabel
                                active={orderBy === headRow.id}
                                direction={orderBy === headRow.id ? order : 'asc'}
                                onClick={createSortHandler(headRow.id)}
                            >
                                {headRow.label}
                                {orderBy === headRow.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}{' '}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
                {/* {post === 'admin' && <TableCell align="center"></TableCell>} */}
                {action && <TableCell align="center"> </TableCell>}
            </TableRow>
        </TableHead>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    thead: {
        fontSize: 16,
        backgroundColor: 'gainsboro',
    },
    tableRow: {
        height: '50px',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },
    popContent: {
        fontFamily: 'Rubik',
        color: '#747474',
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        paddingBottom: '20px',
        '& button': {
            marginLeft: '16px !important',
        },
    },
    btnBluepop: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
    },
    viewBtn: {
        background: '#4c4fa6',
        color: 'white',
        border: 'none',
        padding: '10px 15px !important',
        borderRadius: '6px',
        cursor: 'pointer',
        outline: 'none',
        '&:hover': {
            background: '#4c4fa6 !important'
        }
    },
}));

function descendingComparator(a, b, orderBy) {
    const x = typeof a[orderBy] === 'string' ? a[orderBy].toLowerCase() : a[orderBy];
    const y = typeof b[orderBy] === 'string' ? b[orderBy].toLowerCase() : b[orderBy];
    if (y < x) {
        return -1;
    }
    if (x > y) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => {
        return el[0];
    });
}

const DraftTable = ({ headcells, action, rows, loading, handleRowChange
}) => {
    // const { headcells, action, rows, mode, post, generate } = props; // need to remove
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const history = useHistory();
    const [enableFlag, setEnableFlag] = useState(false);
    const [confirmView, setConfirmView] = useState(false);
    const [flagCheck, setFlagCheck] = useState(false);
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantName = tennantDetails && tennantDetails.tennantName;

    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    const classes = useStyles();
    const dispatch = useDispatch({});

    useEffect(() => {
        // rows.filter((ele) => {})
        console.log('rows', rows)
        rows.filter((ele) => {
            if (ele.finalVersionByIMC) {
                setEnableFlag(true);
            }
        })
    }, [flagCheck])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const navigateTo = (e, row, i) => {
        if (stageId === 16) {
            history.push({
                pathname: '/menu/imc-add-draft',
                state: { data: row, path: "openservices" },
            });
        }
        if (stageId === 17) {
            history.push({
                pathname: '/menu/imc-add-draft-client',
                state: { data: row },
            });
        }
        if (stageId === 18) {
            if (row.remarkByClient) {
                rows[i].viewedByIMC = true;
                rows.map((ele) => ele.date = ele.date.split("-").reverse().join("-"))
                const data = {
                    serviceId: serviceIdValue,
                    remarks: 'Remarks',
                    draftDocuments: rows
                };
                axios
                    .put(`${CommonConfig.dev.baseUrl1}/api/itr/draft-statements/save-em/${tennantName}`, data, {
                        headers: {
                            Authorization: bearerToken,
                        },
                    })
                    .then((response) => {
                        if (response.data === 'SUCCESS') {
                            history.push({
                                pathname: '/menu/imc-add-draft-client',
                                state: { data: row },
                            });
                        }
                    })
                    .catch((error) => {
                        const errResult = error.response;
                        if (errResult && errResult.data) {
                        }
                    });

                dispatch(createIMCDraftRequest({ params: data }));
            } else {
                history.push({
                    pathname: '/menu/imc-add-draft',
                    state: { data: row },
                });
            }
        }
        if (stageId > 18) {
            history.push({
                pathname: '/menu/imc-add-draft',
                state: { data: row },
            });
        }
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleCheckedChange = (e, i) => {
        setFlagCheck(e.target.checked)
        setEnableFlag(false);
        let isPresent = rows.some((ele) => ele.viewedByIMC)
        if (!rows[i].viewedByIMC) {
            return setConfirmView(true);
        }
        rows.filter((ele) => {
            if (ele.finalVersionByIMC === rows[i].finalVersionByIMC) {
                rows[i].finalVersionByIMC = e.target.checked;
            }
            if (ele.finalVersionByIMC) {
                setEnableFlag(true);
            }
        })
        handleRowChange(rows);
    }

    //  row data
    const rowData = (row, i) => {
        return headcells.map((col) => {
            if ((!row.finalVersionByClient && stageId === 16) && col.id === 'finalVersionByClient') {
                return (
                    <TableCell style={{ fontFamily: 'Rubik', color: '#808080' }} align="center">
                        <div>
                            -
                        </div>
                    </TableCell>
                )
            } else if ((row.finalVersionByClient) && col.id === 'finalVersionByClient') {
                return (
                    <TableCell style={{ fontFamily: 'Rubik', color: '#808080' }} align="center">
                        <div>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled
                                        checked={row.finalVersionByClient}
                                        name="checkedA"
                                        color="primary"
                                    />
                                }
                                label=""
                            />
                        </div>
                    </TableCell>
                )
            } else if ((!row.finalVersionByClient && stageId !== 16) && col.id === 'finalVersionByClient') {
                return (
                    <TableCell style={{ fontFamily: 'Rubik', color: '#808080' }} align="center">
                        <div>
                            -
                        </div>
                    </TableCell>
                )
            } else if ((!row.finalVersionByIMC && stageId === 17) && col.id === 'finalVersionByIMC') {
                return (
                    <TableCell style={{ fontFamily: 'Rubik', color: '#808080' }} align="center">
                        <div>
                            -
                        </div>
                    </TableCell>
                )
            }
            if ((stageId === 18) && col.id === 'finalVersionByIMC') {
                return (
                    <TableCell style={{ fontFamily: 'Rubik', color: '#808080' }} align="center">
                        {row ?
                            <div>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={!row.finalVersionByIMC && enableFlag}
                                            checked={row.finalVersionByIMC}
                                            onChange={(e) => handleCheckedChange(e, i, row)}
                                            name="checkedA"
                                            color="primary"
                                        />
                                    }
                                    label=""
                                />
                            </div> : null}
                    </TableCell>
                )
            } else if ((!row.finalVersionByIMC && stageId === 16) && col.id === 'finalVersionByIMC') {
                return (
                    <TableCell style={{ fontFamily: 'Rubik', color: '#808080' }} align="center">
                        <div>
                            -
                        </div>
                    </TableCell>
                )
            } else if ((!row.finalVersionByClient) && col.id === 'finalVersionByClient') {
                return (
                    <TableCell style={{ fontFamily: 'Rubik', color: '#808080' }} align="center">
                        <div>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled
                                        checked={row.finalVersionByClient}
                                        name="checkedA"
                                        color="primary"
                                    />
                                }
                                label=""
                            />
                        </div>
                    </TableCell>
                )
            }
            if (col.isConcat && row[col.id]) {
                const subdata = row[col.id];
                const mergedData = col.concatElem.map((concatdata) => {
                    return concatdata.split('.').reduce((acc, item) => {
                        if (Object.prototype.hasOwnProperty.call(acc, item)) {
                            return acc[item];
                        }
                        return '';
                    }, subdata);
                });
                return (
                    <TableCell align="left" key={col.id}>
                        {mergedData.join(', ')}
                    </TableCell>
                );
            }
            let data = '';
            // if (col.label === 'Status' && row[col.id] === true) {
            //     data = 'Paid';
            // } else if (col.label === 'Status' && row[col.id] !== true) {
            //     if (post === 'ultimate') {
            //         data = 'Unpaid';
            //     } else {
            //         data = <PayHere row={row} />;
            //     }
            // } else {
            //     data = row[col.id];
            // }
            const tabledata = (
                <TableCell align="left" key={col.id}>
                    {row[col.id]}
                </TableCell>
            );
            return tabledata;
        });
    };

    // Action ICONS
    // const actionData = (amode, arow, apost, agenerate) => {
    //     let taction;
    //     if (amode === 'generate') {
    //         taction = (
    //             <div key={amode}>
    //                 <PopUp mode={amode} row={arow} post={apost} generate={agenerate} />
    //             </div>
    //         );
    //     } else if (amode === 'view') {
    //         taction = (
    //             <div key={amode}>
    //                 <Download mode={amode} Icon="download" row={arow} post={apost} />
    //                 <Preview mode={amode} Icon="preview" row={arow} post={apost} />
    //             </div>
    //         );
    //     } else {
    //         taction = (
    //             <div key={amode}>
    //                 <Download mode={amode} Icon="download" row={arow} post={apost} />
    //             </div>
    //         );
    //     }
    //     return taction;
    // };

    // const pagination = (propsPagination) => {
    //     handleCount(propsPagination);
    // };

    // const pagin = () => {
    //     const pag = (
    //         <div style={{ float: 'right', padding: ' 16px', display: 'flex', alignItems: 'baseline' }}>
    //             <div style={{ marginLeft: '10px', paddingBottom: '6px' }}>
    //                 Showing {pageDetails.number + 1} of {pageDetails.totalPages} Pages
    //             </div>

    //             <button className="checklistBtn-openService PNButton" onClick={() => pagination('prev')} disabled={prvnxtbt.prvBt}>
    //                 Previous
    //             </button>

    //             <button className="checklistBtn-openService PNButton" onClick={() => pagination('next')} disabled={prvnxtbt.nxtBt}>
    //                 Next
    //             </button>
    //         </div>
    //     );
    //     return pag;
    // };

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <TableContainer>
                    <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table" size="medium">
                        <colgroup>
                            <col style={{ width: '5%' }} />
                            <col style={{ width: '15%' }} />
                            <col style={{ width: '25%' }} />
                        </colgroup>
                        <EnhancedTableHead
                            classes={classes}
                            headcells={headcells}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            action={action}
                        // post={post}
                        />
                        <TableBody>
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const rowDataShow = rowData(row, index);
                                    let slno = 1;
                                    // if (page > 0) {
                                    //     slno = page * rowsPerPage + 1;
                                    // }
                                    slno += index;
                                    return (
                                        <TableRow hover tabIndex={-1} key={slno} className={classes.tableRow}>
                                            {/* <TableCell>{slno}</TableCell> */}
                                            {rowDataShow}
                                            {action && (
                                                <TableCell style={{ fontFamily: 'Rubik', color: '#808080' }} align="center">
                                                    <div>
                                                        <button
                                                            onClick={(e) => { navigateTo(e, row, index) }}
                                                            className={classes.viewBtn}
                                                        >
                                                            View
                                                        </button>
                                                    </div>
                                                </TableCell>
                                            )}
                                            {/* {post === 'admin' && <TableCell align="center"></TableCell>}
                                            {action && (
                                                <TableCell align="center">
                                                    {
                                                            actionIcons.map(icon => {

                                                               return ( icon.mode === 'generate' ? (
                                                                            <div key={icon.mode}> 
                                                                                <PopUp mode={icon.mode} Icon={icon.icon} row={row} post={post} generate={generate} />
                                                                            </div>
                                                                        ) :
                                                                        icon.mode === 'download' ? (
                                                                            <div key={icon.mode}>
                                                                            <Preview mode={icon.mode} Icon={icon.icon} row={row} post={post} />
                                                                            </div>
                                                                        ) : (
                                                                            <div key={icon.mode}>
                                                                                <Preview mode={icon.mode} Icon={icon.icon} row={row} post={post} />
                                                                            </div>)
                                                               )
                                                                        }) 
                                                        }
                                                    {actionData(mode, row, post, generate)}
                                                </TableCell>
                                            )} */}
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                // <TableRow>
                                //     <TableCell style={{ height: 53 * emptyRows }} colSpan={7} />
                                // </TableRow>
                                <></>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
                {/* {pagin()} */}

            </Paper>
            <Dialog
                open={confirmView}
                onClose={() => setConfirmView(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
            // disableBackdropClick
            >
                <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Confirmation
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.popContent}>
                        <div>It looks like you have not viewed the inputs given by clients.</div>
                        <div>Kindly look into it and then check this box.</div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.popFoot}>
                    <Button onClick={() => setConfirmView(false)} variant="outlined" color="primary" size="small" className={classes.btnBluepop}>
                        Okay
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default DraftTable;
